<app-site-header />
<section class="content-area-layout1">
    <section class="content-area-layout2">
        <p>We're sorry, we do not recognize <b>{{ email }}</b> as a current AeroStar Dynamics Customer or Dealer.</p>
        <p>You will not be able to access AeroStar Dynamics custom software and applications.</p>
        <p>If you feel you have received this in error, then contact AeroStar Dynamics Customer Support.</p>
        <p>Otherwise, feel free to visit the <a href="https://aerostardynamics.com">AeroStar Dynamics</a> web site and
            check out all of the amazing products we have to offer.</p>
        <a [routerLink]="[]" (click)="navigate('login')">Return to login</a>.
    </section>
</section>